module.exports = "//__CDN_HOST__/2.0.8/img/calculator-banner-3.6d60666f.png";